import React from 'react';

import { Center, Icon, Menu, TFText, UnstyledButton } from '@tf/ui';
import { S } from '@tf/utils';

export type Priority = 'LOW' | 'MEDIUM' | 'HIGH';

const PRIORITY = {
	LOW: 'LOW',
	MEDIUM: 'MEDIUM',
	HIGH: 'HIGH',
} as const;

interface Props {
	value?: Priority;
	onChange: (priority: Priority) => void;
}

export const PrioritySelect: React.FC<Props> = ({ value, onChange }) => {
	if (!value) return null;
	return (
		<Menu withinPortal styles={{ item: { padding: '.25rem 1rem' } }}>
			<Menu.Target>
				<UnstyledButton
					sx={({ colors }) => ({
						display: 'flex',
						alignItems: 'center',
						width: '4.5rem',
						height: '1.8rem',
						...(value === PRIORITY.LOW && { color: colors.gray[5] }),
						...(value === PRIORITY.MEDIUM && { color: colors.orange[5] }),
						...(value === PRIORITY.HIGH && { color: colors.red[5] }),
					})}
				>
					<Center opacity={0.7} mr=".5rem">
						<Icon.IconCircleFilled size={10} />
					</Center>

					<TFText
						c="dimmed"
						sx={({ colors }) => ({
							flex: 1,
							fontSize: 13,
							'&:hover': { color: colors.brand[6], textDecoration: 'underline' },
						})}
					>
						{S.prettify(value)}
					</TFText>
				</UnstyledButton>
			</Menu.Target>

			<Menu.Dropdown>
				<Menu.Item onClick={() => onChange(PRIORITY.LOW)} disabled={value === PRIORITY.LOW}>
					<TFText size="sm">{S.prettify(PRIORITY.LOW)}</TFText>
				</Menu.Item>
				<Menu.Item onClick={() => onChange(PRIORITY.MEDIUM)} disabled={value === PRIORITY.MEDIUM}>
					<TFText size="sm">{S.prettify(PRIORITY.MEDIUM)}</TFText>
				</Menu.Item>
				<Menu.Item onClick={() => onChange(PRIORITY.HIGH)} disabled={value === PRIORITY.HIGH}>
					<TFText size="sm">{S.prettify(PRIORITY.HIGH)}</TFText>
				</Menu.Item>
			</Menu.Dropdown>
		</Menu>
	);
};
